'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

// Client objects to communicate with embedded parent IFrame
// Company: Wolters Kluwer / UpToDate
// Author: Iain MacNeill
// Created: Nov 17, 2016

function utdEmbeddedClient(name){

    return {
        sendMessage: function( message, origin ){
            if (typeof origin === "undefined"){
                origin = "*";
            }
			if (typeof window.parent.postMessage !== "undefined"){
				window.parent.postMessage( message, origin );
			}
        },

        addListener: function( callback ){
            if (window.addEventListener){
                window.addEventListener( "message", callback, false );
            }
            else {
                window.attachEvent( "message", callback );
            }
        },

        getIeVersion: function() {
            var sAgent = window.navigator.userAgent;
            var Idx = sAgent.indexOf("MSIE");

            // If IE, return version number.
            if (Idx > 0)
                return parseInt(sAgent.substring(Idx+ 5, sAgent.indexOf(".", Idx)));

            // If IE 11 then look for Updated user agent string.
            else if (!!navigator.userAgent.match(/Trident\/7\./))
                return 11;

            else
                return 0; //It is not IE
        },

        setCookie: function(name, value, days){
            var expires="";
            if (days){
                var d = new Date();
                d.setTime(d.getTime() + (days*24*60*60*1000));
                expires = "expires="+ d.toUTCString() + ";";
            }
            document.cookie = name + "=" + value + ";" + expires + "path=/";
        },

        getCookie: function(name) {
            name += "=";
            var ca = document.cookie.split(';');
            for(var i = 0; i <ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0)==' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length,c.length);
                }
            }
            return "";
        }
    }
}

function utdEpicClient(){
    var token = "NONE",
        active = false,
        origin = "*",
        domain = window.location.protocol + "//" + window.location.hostname,
        client = utdEmbeddedClient("EPIC");

    // Private method which handles messages from Epic parent
    function listener(){
        for (var type in event.data){
            var payload = event.data[type];
            switch (type){
                case "token":
                    token = payload;
                    active = true;
                    // client.setCookie("utdEpicClientServerToken",token);
                    self.bindExternalWindowTargets();
                    break;

                case "error":
                    break;

                case "features":
                    break;

                case "state":
                    break;

                case "actionComplete":
                    break;

                default:
                    break;
            }
        }
    }

    // Private method to send messages to Epic parent, once detected
    function sendMessage( action, args ) {
        client.sendMessage({
            "token": token,
            "action": action,
            "args": args
        }, origin);
    }

    // Private method used to either open a new window directly, or call
    // Epic to open the window if detected
    function openWindow( event, url ){
        event.preventDefault();
        self.windowOpen( url );
        return false;
    }

    function getAllElementsWithAttribute(tagName, attribute, attrValue) {
        var matchingElements = [];
        var allElements = document.getElementsByTagName(tagName);
        for (var i = 0, n = allElements.length; i < n; i++)
        {
            var bAdd = false;
            var attrVal = allElements[i].getAttribute(attribute);
            if (attrVal != null) {
                if ((typeof attrValue !== "undefined") && (attrVal === attrValue)){
                    // Element exists with attribute having value. Add to array.
                    bAdd = true;
                }
                else {
                    // Element exists with attribute. Add to array.
                    bAdd = true;
                }
                if (bAdd && !hasClass(allElements[i], "epicHandled")){
                    matchingElements.push(allElements[i]);
                }
            }
        }
        return matchingElements;
    }

    function hasClass(el, className) {
        if (el.classList)
            return el.classList.contains(className);
        else
            return !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
    }

    function addClass(el, className) {
        if (el.classList)
            el.classList.add(className);
        else if (!hasClass(el, className)) el.className += " " + className;
    }

    // Return public methods
    var self = {
        initialize: function(){
            // Only proceed with this if we're running in an IE browser
            if (client.getIeVersion() > 0){
                // Attach Epic handler to receive messages
                client.addListener( listener );
                // Transmit handshake request after 1 second delay
                setTimeout(function(){
                    client.sendMessage({
                        "action": "Epic.Clinical.Informatics.Web.InitiateHandshake"
                    });
                },1000);
            }
        },

        isActive: function(){
            return active;
        },

        bindExternalWindowTargets: function() {
            var anchors = getAllElementsWithAttribute("a", "target", "_blank");
            for (var ele = 0; ele < anchors.length; ele++){
                if (window.addEventListener){
                    anchors[ele].addEventListener('click', function(e){
                        openWindow(e, e.currentTarget.getAttribute("href"));
                    });
                }
                else {
                    anchors[ele].attachEvent('onclick',function(e){
                        openWindow(e, e.currentTarget.getAttribute("href"));
                    });
                }
                addClass(anchors[ele], "epicHandled");
            }
        },

        windowOpen: function( winUrl ){
            if (!!winUrl) {
                var target = winUrl, title, args;

                if (Array.isArray(winUrl) && winUrl.length > 0) {
                    target = winUrl[0];
                    if (winUrl.length > 1) {
                        title = winUrl[1];
                        if (winUrl.length > 2) {
                            args = winUrl[2];
                        }
                    }
                }

                if (target.toLowerCase().indexOf("http://") == -1 && target.toLowerCase().indexOf("https://") == -1){
                    target = domain + target;
                }

                if (active){
                    sendMessage("Epic.Clinical.Informatics.Web.OpenExternalWindow", [target,title,args]);
                }
                else {
                    // If link is relative, prepend with domain
                    window.open( target, title, args );
                }
            }
        }
    };

    return self;
}

exports.utdEmbeddedClient = utdEmbeddedClient;
exports.utdEpicClient = utdEpicClient;
